import React, {Component} from 'react';
import HeaderBar from './components/HeaderBar';
import {Typography, Grid} from 'material-ui';
import { Helmet } from "react-helmet";

class Tutorial extends Component {
  renderTutorial = () => {
    return (
      <div style={{padding: '1rem'}}>
        <Grid container>
          <Grid item xs={12}>
            <div style={{marginBottom: '1.5rem'}}>
              <Grid container direction="row-reverse" justify="space-between">
                <Grid item xs={12} md={7}>
                  <Typography
                    type="headline"
                    style={{color: 'white'}}
                    gutterBottom
                  >
                    Start & Join
                  </Typography>
                  <Typography type="body2" style={{color: 'white'}}>
                    Ketik <b>/play</b> untuk memulai game
                  </Typography>
                  <Typography type="body2" style={{color: 'white'}}>
                    Lalu pilih mode permainan dari menu. Ada 2 mode permainan, yaitu <b>Normal Game</b> dan <b>Chaos Game</b>
                  </Typography>
                  <Typography type="body2" style={{color: 'white'}}>
                    Lalu teman yang lain hanya perlu menekan tombol join untuk
                    ikut bermain. Pastikan bot memberikan notifikasi bahwa kamu
                    ikut bermain ya..
                  </Typography>
                  <Typography type="body2" style={{color: 'white'}}>
                    Fase join ini berlangsung selama 60 detik dan permainan
                    memerlukan minimum 2 pemain untuk dimulai
                  </Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                  <img
                    src="start_game.jpeg"
                    style={{width: '100%'}}
                    alt="start and join the game"
                  />
                  <Typography
                    type="caption"
                    align="center"
                    style={{color: 'white'}}
                  >
                    Memulai permainan
                  </Typography>
                </Grid>
              </Grid>
            </div>
          </Grid>
          <Grid item xs={12}>
            <div style={{marginBottom: '1.5rem'}}>
              <Grid container justify="space-between">
                <Grid item xs={12} md={7}>
                  <Typography
                    type="headline"
                    style={{color: 'white'}}
                    gutterBottom
                  >
                    Pilih Jempol
                  </Typography>
                  <Typography type="body2" style={{color: 'white'}}>
                    Setiap pemain yang ikut bermain bisa memilih berapa jempol
                    yang akan dia mainkan di ronde ini. Fase ini berlangsung
                    selama <b>60 detik</b>, atau ketika semua pemain sudah
                    memilih jempol.
                  </Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Grid container>
                    <Grid item xs={6}>
                      <img
                        src="pick-1.png"
                        style={{width: '100%'}}
                        alt="pick 1 thumbs"
                      />
                      <Typography
                        type="caption"
                        style={{color: 'white'}}
                        align="center"
                      >
                        Pemain 1 memilih 1 jempol
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <img
                        src="pick-2.png"
                        style={{width: '100%'}}
                        alt="pick 2 thumbs"
                      />
                      <Typography
                        type="caption"
                        style={{color: 'white'}}
                        align="center"
                      >
                        Pemain 1 memilih 2 jempol
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <img
                        src="preview-pick.png"
                        style={{width: '100%'}}
                        alt="pick 2 thumbs"
                      />
                      <Typography
                        type="caption"
                        style={{color: 'white'}}
                        align="center"
                      >
                        Tampilan di kedua pemain
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </div>
          </Grid>
          <Grid item xs={12}>
            <div style={{marginBottom: '1.5rem'}}>
              <Grid container justify="space-between" direction="row-reverse">
                <Grid item xs={12} md={7}>
                  <Typography
                    type="headline"
                    style={{color: 'white'}}
                    gutterBottom
                  >
                    Tebak Jempol
                  </Typography>
                  <Typography type="body2" style={{color: 'white'}}>
                    Bot akan menyebutkan siapa yang harus menebak jumlah jempol
                    yang di pilih. Pemain yang ditunjuk memiliki waktu 30 detik
                    saja untuk menjawab. Apabila waktu habis, maka pemain
                    dianggap menjawab 0.
                  </Typography>
                  <Typography type="body2" style={{color: 'white'}}>
                    Untuk setiap jawaban yang benar, pemain akan mendapatkan
                    poin :
                  </Typography>
                  <Typography type="body2" style={{color: 'white'}}>
                    Pada <b>normal</b> mode, setiap jawaban benar bernilai 1
                  </Typography>
                  <Typography type="body2" style={{color: 'white'}}>
                    Pada <b>Chaos</b> mode, point yang didapat sesuai dengan
                    jempol yang ditebak
                  </Typography>
                  <Typography type="body2" style={{color: 'white'}}>
                    Setelah menjawab, maka kembali ke fase <b>Pilih Jempol</b>{' '}
                    sampai salah satu pemain berhasil mencapai batas point
                    kemenangan atau <i>winning threshold</i>
                  </Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Grid container>
                    <Grid item xs={6}>
                      <img
                        src="correct-answer.png"
                        style={{width: '100%'}}
                        alt="preview correct answer"
                      />
                      <Typography
                        type="caption"
                        style={{color: 'white'}}
                        align="center"
                      >
                        Pemain 1 berhasil menebak dengan benar
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <img
                        src="wrong-answer.png"
                        style={{width: '100%'}}
                        alt="preview incorrect answer"
                      />
                      <Typography
                        type="caption"
                        style={{color: 'white'}}
                        align="center"
                      >
                        Pemain 2 salah menebak jumlah jempol
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </div>
          </Grid>
          <Grid item xs={12}>
            <div style={{marginBottom: '1.5rem'}}>
              <Grid container justify="space-between">
                <Grid item xs={12} md={7}>
                  <Typography
                    type="headline"
                    style={{color: 'white'}}
                    gutterBottom
                  >
                    Akhir Permainan
                  </Typography>
                  <Typography type="body2" style={{color: 'white'}}>
                    Game akan berakhir ketika salah satu pemain berhasil
                    mencapai batas point kemenangan atau
                    <i> winning threshold</i>
                  </Typography>
                  <Typography type="body2" style={{color: 'white'}}>
                    <b>3 point</b> Untuk mode <b>Normal</b>
                  </Typography>
                  <Typography type="body2" style={{color: 'white'}}>
                    <b>10 point</b> atau lebih untuk mode <b>Chaos</b>
                  </Typography>
                  <Typography
                    type="body2"
                    style={{color: 'white'}}
                    gutterBottom
                  >
                    Perlu diperhatikan, batas minimum kemenangan untuk mode
                    chaos bisa lebih tinggi sesuai jumlah pemain yang ikut.
                  </Typography>
                  <Typography
                    type="title"
                    style={{color: 'white', paddingTop: '1rem'}}
                  >
                    Jackpot
                  </Typography>
                  <Typography type="body2" style={{color: 'white'}}>
                    Khusus <b>Chaos mode</b> ada angka jackpot yang bisa pemain
                    dapatkan, yaitu angka <b>0</b>. Jika jumlah jempol yang
                    dipilih sama dengan <b>0</b> dan pemain yang ditunjuk
                    menjawab dengan benar, maka pemain tersebut akan mendapatkan
                    point sebesar<i> winning threshold </i>
                    dan otomatis menjadi pemenang
                  </Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                  <img
                    src="winning-game.png"
                    style={{width: '100%'}}
                    alt="winning the game"
                  />
                  <Typography
                    type="caption"
                    align="center"
                    style={{color: 'white'}}
                  >
                    Pemain berhasil memenangkan game
                  </Typography>
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  };
  render() {
    return (
      <HeaderBar
        title="Adu Jempol Tutorial"
        button="add"
        bodyStyle={{background: '#0081FA'}}
      >
        <Helmet>
          <meta property="og:image" content="AduJempol.png" />
          <meta property="og:url" content="https://thumbbattlebot.firebaseapp.com/tutorial" />
          <meta
            property="og:description"
            content="Cara bermain Adu Jempol"
          />
          <title>Tutorial Adu Jempol</title>
        </Helmet>
        <div>{this.renderTutorial()}</div>
      </HeaderBar>
    );
  }
}

export default Tutorial;



// WEBPACK FOOTER //
// ./src/Tutorial.js